import React from 'react';
import Button from '../../../components/base/Button';

const CTASection: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Transform Your <strong>South Carolina</strong> Office?
        </h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
          Get started with Professional Office Group today. Contact us for a free consultation 
          and discover why we're the preferred office furniture dealer across South Carolina.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button variant="secondary" size="lg" href="/quote">
            <i className="ri-calculator-line mr-2"></i>
            Get Free Quote
          </Button>
          <Button variant="outline" size="lg" href="/contact" className="border-white text-white hover:bg-white hover:text-blue-600">
            <i className="ri-phone-line mr-2"></i>
            Contact Us Today
          </Button>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-orange-400 mb-2">500+</div>
            <div className="text-lg">Satisfied Clients</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-orange-400 mb-2">15+</div>
            <div className="text-lg">Years Experience</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-orange-400 mb-2">24/7</div>
            <div className="text-lg">Customer Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;